<template>
  <div class="flex justify-center lg:justify-start space-x-8">
    <a
      href="https://github.com/upsidefrown"
      target="_blank noopener noreferrer">
      <font-awesome-icon
      class="text-red-400 text-3xl hover:text-red-100"
      :icon="['fab', 'github-alt']" />
      </a>
    <a
      href="https://twitter.com/imaleksey"
      target="_blank noopener noreferrer">
    <font-awesome-icon
      class="text-red-400 text-2-4xl hover:text-red-100"
      :icon="['fab', 'twitter']" />
      </a>
    <a
      href="mailto:hi@aleksey.me"
      target="_blank noopener noreferrer">
    <font-awesome-icon
      class="text-red-400 text-2-4xl font-light hover:text-red-100 align-middle"
      :icon="['fas', 'envelope']" />
      </a>
    <a
      href="https://www.linkedin.com/in/imaleksey/"
      target="_blank noopener noreferrer">
    <font-awesome-icon
      class="text-red-400 text-3xl font-light hover:text-red-100"
      :icon="['fab', 'linkedin-in']" />
      </a>
    <a
      href="resume.pdf"
      target="_blank noopener noreferrer">
    <font-awesome-icon
      class="text-red-400 text-2-3xl font-light hover:text-red-100 align-middle"
      :icon="['fas', 'file-alt']" />
      </a>
  </div>
</template>

<script>
  export default {
    name: 'Social'
  }
</script>
